import { Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

export type PathValues = 'specialty-pharmacy' | 'hub' | 'patient';

@InjectModule({ stateFactory: true }, module)
export default class HubModule extends InjectVuexModule {
    path = '';
    isAuthorizedHubUser = false;

    @Mutation
    setPath(path: 'patient' | 'hub' | 'specialty-pharmacy') {
        this.path = path;
    }

    getPath() {
        if (!this.path) {
            const pathNames: PathValues[] = ['specialty-pharmacy', 'hub', 'patient'];
            const path = pathNames.find(path => window.location.href.includes(path));
            if (path && pathNames.includes(path)) {
                this.setPath(path);
            }
        }
    }

    @Mutation
    setIsAuthorizedHubUser(isAuthorizedHubUser: boolean) {
        this.isAuthorizedHubUser = isAuthorizedHubUser;
    }
}
